import styled from "@emotion/styled"
import { css } from "@emotion/core"
import t from "theme"

const BaseButton = styled.button`
    padding: ${t.space[1]} ${t.space[3]};
    border-radius: 4px;
    text-transform: uppercase;
    font-size: ${t.font.size[2]};

    cursor: pointer;
`

const PrimaryStyle = css`
    background-color: ${t.color.primary};
    border: 2px solid ${t.color.primary};
    color: ${t.color.white};
    font-family: "Open Sans";
    font-weight: ${t.font.weight.semibold};
`

const OutlineStyle = css`
    background-color: ${t.color.white};
    border: 2px solid ${t.color.primary};
    color: ${t.color.primary};
    font-family: "Open Sans";
    font-weight: ${t.font.weight.semibold};
    :hover {
        background-color: ${t.color.light};
    }
`

const Button = styled(BaseButton)`
    ${props => (props.outlined ? OutlineStyle : PrimaryStyle)}
`

export default Button
